/** A calendar entry's status as the app words it (TMMAPP-0103 / 0108). */
import type { MeetingCalendarEntry } from '@/api/meetings';

/** A started, un-ended held meeting is `IN_PROGRESS`; otherwise the occurrence's own status. */
export const entryStatus = (entry: MeetingCalendarEntry) =>
  entry.live ? 'IN_PROGRESS' : entry.status;
